<div class="page-body">
  <div *ngIf="!loading" class="banner">
    <button type="button" class="back-button" (click)="handleCtaClick()">
      <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
      <span>Tillbaka</span>
    </button>
  </div>

  <div *ngIf="!loading && error" class="error-wrapper">
    <div *ngIf="hasFinsharkError" class="contents-container">
      <p class="heading">Någonting gick fel vid anslutningen till din bank.</p>
      <p class="info-text">
        Vänligen prova att ladda om sidan eller försök igen med omdirigering.
      </p>

      <div class="button-container">
        <zaver-primary-button
          text="Försök igen"
          (click)="handleAttemptFinsharkRedirect()"
        ></zaver-primary-button>
      </div>
    </div>

    <div *ngIf="!hasFinsharkError" class="contents-container">
      <p class="heading">Oops! Någonting gick fel.</p>
      <p class="info-text">
        Vänligen prova att ladda om sidan eller försök igen senare.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner></app-spinner>
  </div>

  <div
    *ngIf="iframeUrl && !error"
    class="finshark-iframe-container"
    [class.inside-iframe]="isIframe"
  >
    <app-finshark-iframe
      [iframeUrl]="iframeUrl"
      (onEventData)="onEventData($event)"
    ></app-finshark-iframe>
  </div>

  <div
    *ngIf="!loading && !error && paymentRequest && !iframeUrl"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <app-zaver-icon
        class="icon-user-img"
        [size]="80"
        name="bankSignalCircle"
      ></app-zaver-icon>
      <div class="heading">En snabb extra kontroll</div>

      <div class="sub-heading">
        För din och vår säkerhet behöver vi göra en extra kontroll innan köpet
        kan genomföras. Vänligen välj ditt huvudsakliga bankkonto.
      </div>

      <div class="details">
        <hr class="details-divider" />

        <div class="details-container">
          <div class="details-key-entry">
            {{ paymentRequest.title }}
          </div>

          <zaver-button-link
            text="Ditt köp"
            (click)="toggleModal()"
          ></zaver-button-link>
        </div>

        <hr class="details-divider" />

        <div class="details-container">
          <div class="details-key-entry">Betalsätt</div>

          <div class="details-value-entry">
            {{ paymentMethod }}
          </div>
        </div>

        <hr class="details-divider" />

        <div class="details-container">
          <div class="details-key-entry">Totalbelopp</div>

          <div class="details-value-entry">
            {{
              amount.toLocaleString('sv', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}
            SEK
          </div>
        </div>

        <hr class="details-divider" />
      </div>

      <div class="button-container">
        <zaver-primary-button
          text="Välj huvudbank"
          [disabled]="navigationInProgress || loading"
          (click)="handleContinueClick()"
        ></zaver-primary-button>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
